import { BuildingModel } from './building.model';
import { UserModel } from './user.model';

export class IncidentModel
{
	id: number = undefined;
	dtwrite: any = { date:''};
	nature: string = '';
	dtfacts: any = {date:''};
	description: string = undefined;
	gravity: number = undefined;
	measures: string = undefined;
	instructions: string = undefined;
	building: BuildingModel = new BuildingModel(null);
	redactor: UserModel = new UserModel(null);
	status: string = 'Nouveau';
	cout: string = undefined;
	photo: string = undefined;

	availableStatus = ['Nouveau', 'En cours', 'Résolu'];


	set date(d)
	{
		this.dtfacts.date = d+' '+this.heure;
	}
	set heure(h:any)
	{
		this.dtfacts.date = this.date+' '+h;
	}

	get date()
	{
		if(!this.dtfacts
		|| this.dtfacts.date==undefined
		|| this.dtfacts.date=='') return '';
		
		return this.dtfacts.date.split(' ')[0];
	}
	get heure()
	{
		if(!this.dtfacts
		|| this.dtfacts.date==undefined
		|| this.dtfacts.date=='') return '';
		
		let heure = this.dtfacts.date.split(' ')[1].split(':');
		if(heure.length>2) heure.pop();
		return heure.join(':');
	}

	get writeDate()
	{
		if(!this.dtwrite
		|| !this.dtwrite.date)
		{
			this.dtwrite = { date : new Date() };
		}

		if(typeof this.dtwrite.date != 'string')
		{
			this.dtwrite.date = new Date(this.dtwrite.date+'UTC').toISOString();
		}

		return this.dtwrite.date;
	}
	

	constructor(values) {
		this.exchange(values, false);
	}
	
	exchange(values: Object = {}, isObject=false) {
	    for (let p in values) {

		    if (this.hasOwnProperty(p) && values.hasOwnProperty(p)) {
		    	if(p == 'id' && this.id != undefined) {
		    		continue;
		    	}
		    	else {
		    		if(isObject) this[p].exchange(values[p]);
		    		else this[p] = values[p];
		    	} 
		    }
		    else if (p == '_embedded') {
	    		this.exchange(values[p], true);
	    	} else {

	    	}
		}
		//this.makeDateTime();
	}

	export()
	{
		console.log('export incident', this.dtfacts);
		return {
			id: this.id,
			dtwrite: this.writeDate,
			nature: this.nature,
			dtfacts: this.dtfacts.date,
			description: this.description,
			gravity: this.gravity,
			measures: this.measures,
			instructions: this.instructions,
			building: this.building.id,
			redactor: this.redactor.id,
			status: this.status,
			cout: this.cout,
			photo: this.photo
		}
	}
}